<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-data-table
          :headers='headers'
          :items='itens'
          class='elevation-1'
          :items-per-page="itemsPerPage"
          @update:items-per-page=" v => itemsPerPage = v"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat color='white'>
              <v-toolbar-title v-text="$t('keywords.listing')" />
              <v-divider class='mx-4' inset vertical></v-divider>
              <v-btn v-has-permission="['desenvolvedor', 'credenciador']" color='primary' dark class='mb-2' @click="editItem(null)">{{ $t('button.new') }}</v-btn>
              <ImportExportCredentials @import="searchAll()" />
            </v-toolbar>
            <v-toolbar flat color='white'>
              <v-row>
                <SearchField v-model="credentialSearch" :label="$t('credentials.search.credential')" />
                <SearchField v-model="userSearch" :label="$t('credentials.search.user')" />
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:item.lastModified='{ item }'>
            <LastModify :date="item.lastModified" :by="item.lastModifiedBy"/>
          </template>
          <template v-slot:item.actions='{ item }'>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="orange" small class='mr-2' @click='editItem(item)'>mdi-pencil</v-icon>
              </template>
              <span>{{$t('button.edit')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-has-permission="['desenvolvedor', 'credenciador']" v-on="on" color="red" small class='mr-2' @click='deleteItem(item)'>mdi-delete</v-icon>
              </template>
              <span>{{$t('button.delete')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="secondary" small class='mr-2' @click='exportItem(item)'>mdi-export</v-icon>
              </template>
              <span>{{ $t('core.import_export.export') }}</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            {{ $t('warnings.no_data_found') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/CredentialsService'
import ImportExportService from '@/services/ImportExportService'
import IncludesIgnoreCase from '../../utils/IncludesIgnoreCase'
import LastModify from '../core/LastModify.vue'
import SearchField from '../core/SearchField.vue'
import ImportExportCredentials from './ImportExportCredentials.vue'

export default {
  name: 'credentialGrid',

  components: {
    LastModify,
    SearchField,
    ImportExportCredentials
  },

  data: () => ({
    search: '',
    credentialSearch: '',
    userSearch: '',
    itens: [],
    cronExpressionResult: ''
  }),

  computed: {
    version () { return this.$versionable.versions.credentials },
    itemsPerPage: {
      get () {
        return this.$cookies.isKey('credentials_per_page') ? parseInt(this.$cookies.get('credentials_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('credentials_per_page', value)
      }
    },
    headers () {
      return [
        {
          text: this.$t('credentials.name'),
          value: 'credentialName',
          sortable: false,
          align: 'start',
          filter: credentialName => IncludesIgnoreCase(credentialName, this.credentialSearch)
        },
        {
          text: this.$t('keywords.last_modify'),
          value: 'lastModified',
          sortable: true,
          show: this.version > '1.0.0'
        },
        {
          text: this.$t('keywords.username'),
          value: 'username',
          sortable: false,
          align: 'start',
          filter: username => IncludesIgnoreCase(username, this.userSearch)
        },
        {
          text: this.$t('keywords.actions'),
          value: 'actions',
          sortable: false
        }
      ].filter(h => h.show ?? true)
    }
  },
  mounted () {
    this.searchAll()
  },

  methods: {

    searchAll () {
      this.itens = []
      Servico.findAll()
        .then((result) => (this.itens = result.data))
    },

    editItem (item) {
      this.$emit('editItem', false, item)
    },

    deleteItem (item) {
      if (confirm(this.$t('warnings.confirm.delete'))) {
        Servico.delete(item)
          .then(() => this.searchAll())
          .catch((error) => this.$message.error(`${this.$t('warnings.error.delete')} : ${error}`))
      }
    },

    exportItem (item) {
      if (confirm(this.$t('warnings.confirm.export'))) {
        ImportExportService.export('credentials', item.credentialName)
          .then(() => this.$message.error(this.$t('warnings.success.export')))
          .catch(error => this.$message.error(`${this.$t('warnings.error.export')} : ${error}`))
      }
    }
  }
}
</script>
